import React from 'react';
import { Link } from 'react-router-dom';
import './App.css';

function PrivacyPolicy() {
  return (
    <div className="app">
      {/* Navigation */}
      <nav className="navbar">
        <div className="nav-container">
          <Link to="/" className="logo">
            <img src="/School logo.png" alt="AJWS Logo" className="logo-image" />
            <div className="logo-text">
              <span className="logo-title">AJWS</span>
              <span className="logo-subtitle">Anil Jindal World School</span>
            </div>
          </Link>
          <div className="nav-links">
            <Link to="/">Home</Link>
            <Link to="/support">Support</Link>
          </div>
        </div>
      </nav>

      <section className="policy-section">
        <div className="container">
          <div className="policy-content">
            <h1 className="policy-title">Privacy Policy</h1>
            <p className="policy-date">Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>

            <div className="policy-text">
              <p>
                Anil Jindal World School ("we," "our," or "us") is committed to protecting your privacy. 
                This Privacy Policy explains how we collect, use, disclose, and safeguard your information 
                when you use our mobile application and related services.
              </p>

              <h2>1. Information We Collect</h2>
              
              <h3>1.1 Personal Information</h3>
              <p>We may collect the following types of personal information:</p>
              <ul>
                <li><strong>Account Information:</strong> Name, email address, phone number, and role (parent, teacher, administrator, principal)</li>
                <li><strong>Student Information:</strong> Student names, grades, classes, attendance records, academic progress, and homework assignments</li>
                <li><strong>School Information:</strong> School name, class schedules, timetable information, and school events</li>
                <li><strong>Communication Data:</strong> Messages sent through the app between parents and teachers</li>
                <li><strong>Usage Data:</strong> Information about how you use the app, including features accessed and time spent</li>
              </ul>

              <h3>1.2 Automatically Collected Information</h3>
              <p>When you use our app, we may automatically collect:</p>
              <ul>
                <li>Device information (device type, operating system, unique device identifiers)</li>
                <li>Log data (IP address, access times, app features used)</li>
                <li>Location data (if location services are enabled)</li>
              </ul>

              <h2>2. How We Use Your Information</h2>
              <p>We use the collected information for the following purposes:</p>
              <ul>
                <li>To provide and maintain our school management services</li>
                <li>To enable communication between parents, teachers, administrators, and principals</li>
                <li>To track and display student academic progress, homework, and attendance</li>
                <li>To send school announcements, notifications, and important updates</li>
                <li>To process leave requests and manage school-related activities</li>
                <li>To improve our app and develop new features</li>
                <li>To ensure security and prevent fraud</li>
                <li>To comply with legal obligations</li>
              </ul>

              <h2>3. Data Sharing and Disclosure</h2>
              <p>We do not sell your personal information. We may share your information in the following circumstances:</p>
              <ul>
                <li><strong>Within the School Community:</strong> Information relevant to your role (e.g., teachers can see student information for their classes, parents can see their children's information)</li>
                <li><strong>Service Providers:</strong> With trusted third-party service providers who assist us in operating our app (e.g., cloud hosting, analytics)</li>
                <li><strong>Legal Requirements:</strong> When required by law or to protect our rights and safety</li>
                <li><strong>School Administration:</strong> With school administrators and principals for school management purposes</li>
              </ul>

              <h2>4. Data Security</h2>
              <p>
                We implement appropriate technical and organizational security measures to protect your personal information 
                against unauthorized access, alteration, disclosure, or destruction. These measures include:
              </p>
              <ul>
                <li>Encryption of data in transit and at rest</li>
                <li>Secure authentication and access controls</li>
                <li>Regular security assessments and updates</li>
                <li>Limited access to personal information on a need-to-know basis</li>
              </ul>
              <p>
                However, no method of transmission over the internet or electronic storage is 100% secure. 
                While we strive to protect your information, we cannot guarantee absolute security.
              </p>

              <h2>5. Data Retention</h2>
              <p>
                We retain your personal information for as long as necessary to provide our services and fulfill 
                the purposes outlined in this Privacy Policy. When you delete your account or when retention is 
                no longer necessary, we will securely delete or anonymize your information in accordance with 
                applicable laws and school policies.
              </p>

              <h2>6. Your Rights and Choices</h2>
              <p>Depending on your location, you may have the following rights:</p>
              <ul>
                <li><strong>Access:</strong> Request access to your personal information</li>
                <li><strong>Correction:</strong> Request correction of inaccurate or incomplete information</li>
                <li><strong>Deletion:</strong> Request deletion of your personal information</li>
                <li><strong>Data Portability:</strong> Request a copy of your data in a portable format</li>
                <li><strong>Opt-Out:</strong> Opt out of certain data collection and processing activities</li>
                <li><strong>Account Deletion:</strong> Delete your account and associated data</li>
              </ul>
              <p>To exercise these rights, please contact us using the information provided in the "Contact Us" section below.</p>

              <h2>7. Children's Privacy</h2>
              <p>
                Our app is designed for use by parents, teachers, administrators, and principals to manage 
                student information. Student information is collected and processed with appropriate consent 
                from parents or legal guardians and in accordance with applicable laws protecting children's privacy.
              </p>
              <p>
                We do not knowingly collect personal information directly from children under the age of 13 
                without parental consent. If you believe we have collected information from a child without 
                proper consent, please contact us immediately.
              </p>

              <h2>8. Third-Party Services</h2>
              <p>
                Our app may contain links to third-party websites or services. We are not responsible for 
                the privacy practices of these third parties. We encourage you to review the privacy policies 
                of any third-party services you access through our app.
              </p>

              <h2>9. International Data Transfers</h2>
              <p>
                Your information may be transferred to and processed in countries other than your country 
                of residence. These countries may have data protection laws that differ from those in your 
                country. By using our app, you consent to the transfer of your information to these countries.
              </p>

              <h2>10. Changes to This Privacy Policy</h2>
              <p>
                We may update this Privacy Policy from time to time. We will notify you of any changes by 
                posting the new Privacy Policy on this page and updating the "Last Updated" date. You are 
                advised to review this Privacy Policy periodically for any changes.
              </p>

              <h2>11. Contact Us</h2>
              <p>If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us:</p>
              <div className="contact-info">
                <p><strong>Nyx Solutions</strong></p>
                <p><strong>Email:</strong> <a href="mailto:solutionnyx@gmail.com">solutionnyx@gmail.com</a></p>
                <p><strong>Phone:</strong> <a href="tel:+919765723830">+91 9765723830</a></p>
                <p><strong>Address:</strong> A 23/3, R K PLASTRONICS, MIDC AREA, JALNA, Maharashtra, 431203</p>
                <p>For support inquiries, please visit our <Link to="/support">Support page</Link></p>
              </div>

              <h2>12. Consent</h2>
              <p>
                By using our app, you consent to the collection and use of your information in accordance 
                with this Privacy Policy. If you do not agree with this policy, please do not use our app.
              </p>
            </div>
          </div>
        </div>
      </section>

      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-logo">
              <img src="/School logo.png" alt="AJWS Logo" className="logo-image" />
              <div className="logo-text">
                <span className="logo-title">AJWS</span>
                <span className="logo-subtitle">Anil Jindal World School</span>
              </div>
            </div>
            <div className="footer-links">
              <div className="footer-column">
                <h4>Resources</h4>
                <Link to="/privacy-policy">Privacy Policy</Link>
                <Link to="/support">Support</Link>
                <Link to="/">Home</Link>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; {new Date().getFullYear()} Anil Jindal World School. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default PrivacyPolicy;

